import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { history } from "../../../utils/history";
import { Grid, Button, TextField, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Formik, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { formSchema } from "./form-schema";
import { toast } from "react-toastify";
import {
  getForms,
  getForm,
  getFormSelector,
  getFormsSelector,
  saveForm,
} from "../../../store/admin";
import { getConfiguration, getSettings } from "../../../store/setting";
import formService from "../../../services/formService";

const useStyles = makeStyles((theme) => ({
  backArrowOutter: theme.backArrowOutter,
  darkArrow: theme.darkArrow,
  form: theme.form,
  select: theme.select,
}));

const Form = ({ ...props }) => {
  const classes = useStyles();
  const params = useParams();
  const {
    form = {},
  } = props;
  const [disabledSubmit, setDisableSubmit] = useState(false);

  useEffect(() => {
    const init = async () => {
      const { getForm, getForms, getSettings } = props;

      await getSettings();
      await getForms();

      if (params.id !== "new") await getForm(params.id);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSave = async (values) => {
    setDisableSubmit(true);
    const {
      saveForm,
      forms,
    } = props;

    const form = {
      id: params.id === "new" ? 0 : params.id,
      name: values.name,
      apiPath: values.apiPath,
    };

    const exists = forms.find((f) => f.name === form.name);

    //check the form.io API
    try {
      await formService.testForm(
        props.configuration.formioLiveEndpoint,
        values.apiPath
      );
    } catch (ex) {
      toast.error(
        `API test failed, please make sure ${form.apiPath} exists in Form.io`
      );
      setDisableSubmit(false);
      return;
    }

    if (exists && exists.id !== parseInt(params.id)) {
      toast.error(`Form already exists with name ${form.name}`);
      setDisableSubmit(false);
      return;
    } else {
      await saveForm(form);
      history.push("/form-management");
    }
  };

  return (
    <Fragment>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.backArrowOutter}>
          <span
            onClick={(e) => history.push("/form-management")}
            className={classes.darkArrow}
          >
            <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to Forms{" "}
          </span>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom sx={{ color: "primary.main" }}>
            {params.id === "new"
              ? "Add Form"
              : `Edit ${form.name || `Form ${params.id}`}`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Formik
            enableReinitialize={true}
            initialValues={{
              name: form.name ? form.name : "",
              apiPath: form.apiPath ? form.apiPath : "",
            }}
            validationSchema={formSchema}
            onSubmit={(values) => {
              handleSave(values);
            }}
            render={({
              values,
              setFieldValue,
              handleChange,
              handleSubmit,
              handleBlur,
              errors,
              touched,
              ...formProps
            }) => (
              <form onSubmit={handleSubmit} className={classes.form}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      error={errors.name && touched.name ? true : false}
                      name="name"
                      type="text"
                      label="Name"
                      margin="normal"
                      fullWidth
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                    />
                    <ErrorMessage name="name">
                      {(msg) => (
                        <div className="error error-message">{msg}</div>
                      )}
                    </ErrorMessage>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      error={errors.apiPath && touched.apiPath ? true : false}
                      name="apiPath"
                      type="text"
                      label="API Path"
                      margin="normal"
                      fullWidth
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.apiPath}
                    />
                    <ErrorMessage name="apiPath">
                      {(msg) => (
                        <div className="error error-message">{msg}</div>
                      )}
                    </ErrorMessage>
                  </Grid>

                  <Grid item xs={12} sx={{ textAlign: "right" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={disabledSubmit}
                    >
                      Save Form
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    form: getFormSelector(state),
    forms: getFormsSelector(state),
    configuration: getConfiguration(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(
      { getForm, getForms, saveForm, getSettings },
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
